
import { map, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { RenewalContactInfo } from '../app/models/renewal-contact-info';
import { RenewalOtherOccupantForm } from 'app/models/renewal-other-occupant-form';
import { PetType } from '../app/models/pettype';
import { RenewalRoommateInfo } from 'app/models/renewal-roommate-info';
import { ConfirmEmployerCard } from 'app/models/renewal-confirm-employer-card';
import { RenewalChoosePlan } from 'app/models/renewal-choose-plan';
import { RenewalVerify } from 'app/models/renewal-verify';
import { CognitoUtil } from './cognito.service';
import { RenewalCard } from '../app/models/renewal-card';

@Injectable()
export class RenewalCogService {
    public static _API_ENDPOINT = environment.apiEndPoint;

    constructor(private http: HttpClient, private router: Router, private cognitoUtil: CognitoUtil) { }

    createOptions() {
        this.cognitoUtil.refresh();
        return {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': localStorage.getItem('AWSCreds'),
                'Identity': localStorage.getItem('CognitoId'),
                'Sub': localStorage.getItem('CognitoSub')
            })
        };
    }


    updateContactInfo(model: RenewalContactInfo) {
        return this.http.post(RenewalCogService._API_ENDPOINT + 'RenewalCog/UpdateRenewalContactInfo', model, this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <RenewalContactInfo>(response))
            );
    }

    getRenewalContactInfo(model: RenewalContactInfo) {
        return this.http.post(RenewalCogService._API_ENDPOINT + 'RenewalCog/GetRenewalContactInfo', model, this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <RenewalContactInfo>(response))
            );
    }

    getOtherOccupantFormInfo(model: RenewalOtherOccupantForm) {
        return this.http.post(RenewalCogService._API_ENDPOINT + 'RenewalCog/GetRenewalOtherOccupantFormInfo', model, this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <RenewalOtherOccupantForm>(response))
            );
    }

    updateOtherOccupantFormInfo(model: RenewalOtherOccupantForm) {
        return this.http.post(RenewalCogService._API_ENDPOINT + 'RenewalCog/UpdateRenewalOtherOccupantFormInfo', model, this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <RenewalOtherOccupantForm>(response))
            );
    }

    getRentalPetTypesRenewal(leaseRenewalKey: number) {
        return this.http.get(RenewalCogService._API_ENDPOINT + 'RenewalCog/GetPetTypesRenewal?leaseRenewalKey=' + leaseRenewalKey, this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <PetType[]>(response))
            );
    }

    getRenewalRoommateInfo(model: RenewalRoommateInfo) {
        return this.http.post(RenewalCogService._API_ENDPOINT + 'RenewalCog/GetRenewalRoommateInfo', model, this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <RenewalRoommateInfo>(response))
            );
    }

    updateRenewalRoommateInfo(model: RenewalRoommateInfo) {
        return this.http.post(RenewalCogService._API_ENDPOINT + 'RenewalCog/UpdateRenewalRoommateInfo', model, this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <RenewalRoommateInfo>(response))
            );
    }

    getChosenPlanInfo(model: RenewalChoosePlan) {
        return this.http.post(RenewalCogService._API_ENDPOINT + 'RenewalCog/GetRenewalChosenPlanInfo', model, this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <RenewalChoosePlan>(response))
            );
    }

    updateChosenPlanInfo(model: RenewalChoosePlan) {
        return this.http.post(RenewalCogService._API_ENDPOINT + 'RenewalCog/UpdateRenewalChosenPlanInfo', model, this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <RenewalChoosePlan>(response))
            );
    }

    getRenewalsForDashboard() {
        return this.http.get(RenewalCogService._API_ENDPOINT + 'RenewalCog/GetRenewalsForDashboard', this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <RenewalCard[]>(response))
            );
    }

    getEmployerConfirmationForDashboard() {
        return this.http.get(RenewalCogService._API_ENDPOINT + 'RenewalCog/GetRoommateEmployerConfirmationForDashboard', this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <ConfirmEmployerCard[]>(response))
            );
    }

    getRenewalPropertyBaseRent(leaseRenewalKey: number) {
        return this.http.get(RenewalCogService._API_ENDPOINT + 'RenewalCog/GetRenewalPropertyBaseRent?leaseRenewalKey=' + leaseRenewalKey, this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <number>(response))
            );
    }

    handleError(error: HttpErrorResponse | any) {
        let errMsg: string;
        if (error.status === 403) {
            this.router.navigate(['/logout']);
        }
        if (error.error instanceof ErrorEvent) {
            const body = error.error;
            if (body.message) {
                errMsg = error.error.message;
            } else {
                const err = body;
                errMsg = `${error.statusText || ''} ${err}`;
            }
        } else {
            errMsg = error.message ? error.message : error.toString();
            if (errMsg.length === 0) {
                errMsg = 'There was an unknown error.  Please try again later';
            }
        }

        localStorage.setItem('RenewalErrorMessage', errMsg);
        this.router.navigate(['renewalcog/renewal-error']);
        return errMsg;
    }

}
